export default "__VITE_ASSET__765275eb__"